import { memo } from 'react';
import NumberFlow from '@number-flow/react';
export const TimeLeftCountdown = memo(({ hours, minutes, seconds }) => {
    return (<>
			{/* hours */}
			<NumberFlow className="text-inherit" value={hours} format={{ minimumIntegerDigits: 2 }}/>
			:
			{/* minutes */}
			<NumberFlow className="text-inherit" value={minutes} format={{ minimumIntegerDigits: 2 }}/>
			:
			{/* seconds */}
			<NumberFlow className="text-inherit" value={seconds} format={{ minimumIntegerDigits: 2 }}/>
		</>);
});
